import { freshModal } from "../../components/freshModal";
import ClientForm from "./ClientForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "../../components/reusableComponents/Dialog";

function CreateClientModalFormSession({ open, clients, setClients, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[850px] p-0 overflow-hidden bg-white rounded-xl">
        <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 py-4 px-6">
          <DialogTitle className="text-xl font-semibold text-white mb-1">
            Nouveau client
          </DialogTitle>
          <DialogDescription className="text-indigo-100">
            Créez une nouveau client
          </DialogDescription>
        </div>

        <ClientForm
          clients={clients}
          setClients={setClients}
          close={onOpenChange}
        />
      </DialogContent>
    </Dialog>
  );
}


export default freshModal(CreateClientModalFormSession, "open");
